import { fetchApi } from '@/config/axiosSetting.ts';
import { alertsQueryResponseType } from '@/modules/FileDetail/queries/alerts/alertsQuery.type.ts';

export const alertQueryFunction = (
  id: string,
): Promise<alertsQueryResponseType> =>
  fetchApi.get(`/my_files/${id}/file_alert/`);
